(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bmb-video-preview"] && !Shopify.designMode) return;
  try {
    if (!window.bmbVideoPreviewReady) {
    window.bmbVideoPreviewReady = true;
    let active = null;
    function reset() {
      if (!active) return;
      active.player.remove();
      active.button.hidden = false;
      active = null;
    }
    document.addEventListener('click', function (event) {
      const button = event.target.closest('button[data-bmb-video-id]');
      if (!button) return;
      const container = button.closest('[data-bmb-video-preview]');
      const id = button.dataset.bmbVideoId;
      if (!container || !/^[a-zA-Z0-9_-]{11}$/.test(id || '')) return;
      reset();
      const player = document.createElement('iframe');
      player.title = button.getAttribute('aria-label');
      player.dataset.bmbActive = '1';
      player.allow = 'encrypted-media; picture-in-picture; fullscreen';
      player.allowFullscreen = true;
      player.src = 'https://www.youtube.com/embed/' + id + '?rel=0&playsinline=1';
      button.hidden = true;
      container.appendChild(player);
      active = { player, button };
      player.focus();
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden) reset(); });
    document.addEventListener('shopify:section:unload', function (event) {
      if (active && event.target.contains(active.player)) reset();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
